import { IPromise } from "angular";
import { MaintenanceHistory } from "../../entities/MaintenanceHistory";
import { MaintenanceHistoryService } from "../../services/MaintenanceHistoryService";
import { NotificationService } from "../../services/NotificationService";
import { IEditMaintenanceHandler } from "./IEditMaintenanceHandler";

export class EditMaintenanceHandler_EditAsset implements IEditMaintenanceHandler {

    static $inject = ['$q', 'MaintenanceHistoryService', 'NotificationService'];

    constructor(public $q: ng.IQService, public mhService: MaintenanceHistoryService, public notifyService: NotificationService) {

    }
    deleteMaintenance(entity: MaintenanceHistory): IPromise<boolean> {
        return this.mhService.delete([entity.id]).then(() => {
            return this.$q.when<boolean>(true);
        })
        .catch((err: any) => {
            return this.$q.reject("Got error in deleting maintenance history:" + err);
        });
    }
    addMaintenance(entity: MaintenanceHistory): IPromise<boolean> {
        return this.mhService.insert(entity).then(() => {
            return this.$q.when<boolean>(true);
        })
        .catch((err: any) => {
            return this.$q.reject("Got error in adding maintenance history:" + err);
        });
    }
    editMaintenance(entity: MaintenanceHistory): IPromise<boolean> {
        return this.mhService.update(entity).then(() => {
            return this.$q.when<boolean>(true);
        })
        .catch((err: any) => {
            return this.$q.reject("Got error in editing maintenance history:" + err);
        });
    }
    saveData(entityId: number): IPromise<boolean> {
        return this.$q.when<boolean>(true);
    }
}
